// extracted by mini-css-extract-plugin
export default {"container":"styles_container__qnl2l","title":"styles_title__JcLgq","action":"styles_action__b0S2o","image":"styles_image__wIOpO"};